"use strict";

(function (global) {

  /**
 * Класс-обертка для коллекции закладок
 * @class WebAccess.components.wrappers.sideBar.Tabs
 * @extends WebAccess.Collecton
 * @since 5.2.0.1600  
 */
  var Tabs = global.Collection.extend({
    _tabSelector: 'div.tab_item',
    _byNameSelectorTemplate: '{0}[name="{1}"]',
    _cardFormTabTemplate: '#CardForm_Tab_{0}',
    _cardFormTabSelector: 'div.CardForm_Tab',
    _cssClass: 'tab_item',
    _noCardFormAtStartFound: false,
    _current: null,

    init: function (elements, sideBarConatainerSelector, opt_current) {
      var me = this;
      me._super(elements);
      me._current = opt_current;
      me._jSideBarConatainer = $(sideBarConatainerSelector);
      me._jPlaceHolder = me._jSideBarConatainer.find("span:first");

      me._jCardForm = $(".CardForm, .FakeCardForm");
      me._jScroller = $("#scroller");
      me._jAfterTabs = $(".after_tabs");
      me._jSideBar = $('#card_left_container');
      me._actualizeCurrentOnClick();

      // Подписываемся на изменение активной вкладки.
      if (me._current && me._current.sideBar) {
        var currentSidebar = me._current.sideBar;
        currentSidebar.bind(currentSidebar['class'].EVENT.AFTER_TAB_SWITCH, function () {
          me._updateCurrentSelectedTab();
        });
      }

    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    /**
    * Слежение за тем, какая закладка текущая
    * @private
    */
    _actualizeCurrentOnClick: function () {
      var me = this;
      me._jSearchTarget = me._jSideBarConatainer.bind('click', function () {
        me._updateCurrentSelectedTab();
      });
      me._updateCurrentSelectedTab();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    /**
    * Слежение за тем, какая закладка текущая
    * @private
    */
    _updateCurrentSelectedTab: function () {
      var me = this;
      me._jSelectedTab = me._jSideBarConatainer.find(me._tabSelector + '.selected');
      if (!me._jSelectedTab.length)
        me._jSelectedTab = me._jSideBarConatainer.find(me._tabSelector + '.first');
      var name = me._jSelectedTab.attr('name') || me._jSelectedTab.data('name');
      me.current = me[name];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создать новую закладку боковой панели.
    * 
    * @method WebAccess.components.wrappers.sideBar.Tabs#create
    * @param {string|object} tabName Имя закладки или объект 
    * {name: "", label:"", action:"", icon:""}
    * @throws ERR_TAB_NAME_IS_NOT_SPECIFIED_PROPERLY – неверно указанно имя закладки;
    * @throws ERR_TAB_WITH_THE_SAME_NAME_ALREADY_EXIST – закладка с указанным
    * именем уже существует.
    * @return {WebAccess.components.wrappers.sideBar.Tab} Объект типа Tab.     
    */
    create: function (tabName) {
      var me = this;

      var name = "";
      var label = L("NEW_TAB");
      var icon = "Doc/doc_32.png";
      var toolTip = label;

      if (typeof tabName == "object") {
        name = tabName.name || tabName.id;
        label = tabName.label || tabName.text;
        icon = tabName.icon || icon;
        toolTip = tabName.toolTip || tabName.tooltip;
      } else if (typeof tabName == "string") {
        name = tabName;
      } else global.raise("ERR_TAB_NAME_IS_NOT_SPECIFIED_PROPERLY");

      me._currentTabSelector = format(me._byNameSelectorTemplate, me._tabSelector, name);
      me._jExistingTab = me._jSideBarConatainer.find(me._currentTabSelector);

      if (me._jExistingTab.length > 0) {
        global.raise("ERR_TAB_WITH_THE_SAME_NAME_ALREADY_EXIST", name);
      };

      var template = format(ControlTemplate.sideBar.tab, name, label, icon, me._cssClass, toolTip);

      if (me._jPlaceHolder.find('.more').length) {
        me._jAfterTabs.append(template);
      } else {
        me._jPlaceHolder.append(template);
      }

      me._jSideBarConatainer.find(me._currentTabSelector).addClass("last")
          .prev().removeClass("last");

      this._preparePage(name);


      var tab = new global.components.wrappers.sideBar.Tab(me._currentTabSelector, me._current);


      tab.bind('click', function () { me._defaultClickHandler(this, name, me._currentTabSelector) });
      tab.isSynthetic = true;

      tab.setHtml(format(ControlTemplate.form.tabHelp, L("NEW_TAB"), L("WRN_USE_SET_HTML_HELP_TEXT"), L("OM_HELP_HYPERLINK")));
      me.addElement(name, tab);

      if (tabName['jsaction']) {
        tab.bind('click', tabName['jsaction']);
      };
      return tab;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Устанавливает обработку события щелчка, для измененной DOM структуры.
    *
    * @private 
    * @method WebAccess.components.wrappers.sideBar.Tabs#_bindOpenHandler
    * @property tabName имя закладки
    */
    _bindOpenHandler: function (tabName) {
      var me = this;
      me._current.sideBar.tabs.current.click(function (tabName) {
        var currentTabSelector = format(me._byNameSelectorTemplate, me._tabSelector, tabName);
        me._openHandler(tabName, currentTabSelector);
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Новые кнопки тоже должны уметь делать expand/collapse
    * @private
    */
    _defaultClickHandler: function (element, name, currentTabSelector) {
      var me = this;
      if (name !== "FldTree" && name !== "Run") me._openHandler(name, currentTabSelector);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выбор активной закладки/
    *
    * @private
    * @method WebAccess.components.wrappers.sideBar.Tabs#_openHandler
    * @property tabName имя закладки
    * @property me._tabSelector селектор закладки
    */
    _openHandler: function (tabName, targetTabSelector) {
      var me = this;
      me._jCardForm.find(me._cardFormTabSelector).hide();
      $(me._tabSelector).removeClass('selected');
      me._jSideBarConatainer.find(targetTabSelector).addClass('selected');
      if (me._current.className !== "FormDialog") {
        window.location.hash = tabName;
      }
      me._jCardForm.find(format(me._cardFormTabTemplate, tabName)).show();

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создает имитацию поддержки табов, там где карточки не существует. 
    * Для возможности переключения табов.
    *
    * @private 
    * @method WebAccess.components.wrappers.sideBar.Tabs#_preparePage
    * @param {string} name
    */
    _preparePage: function (name) {

      var me = this;
      if (me._current.sideBar.tabs.hasOwnProperty("current")) {
        var currentTabName = me._current.sideBar.tabs.current.name;
        //Если изначально поддержки табов не было, сделаем их сами.
        if (me._jCardForm.length == 0) {
          me.noCardFormAtStartFound = true;
          if (me._jScroller.children("div").length === 1) {
            //Если справочник, но закладка без формы
            me._jScroller.children("div").addClass("FakeCardForm");
          } else {
            //Если мы в ЗЗУ
            me._jScroller.wrapInner('<div id="CardForm_Tab_' + currentTabName + '" class="CardForm_Tab">');
            me._jScroller.wrapInner('<div class="FakeCardForm">');
          }
        };

        me._jCardForm = $(".CardForm, .FakeCardForm");

        //Если содержимое текущей закладки не обернуто в div для таба
        if ($(me._cardFormTabSelector).length == 0) {
          me._jCardForm.wrapInner('<div id="CardForm_Tab_' + currentTabName + '" class="CardForm_Tab">');
          //jCardForm.addClass('CardForm_Tab').attr('id', 'CardForm_Tab_' + currentTabName);
          this._bindOpenHandler(currentTabName);
        };

        if (!me._current.sideBar.tabs.current._jObject.hasClass("inline_tab")) {
          this._bindOpenHandler(currentTabName);
        }
        var template = format(ControlTemplate.form.tab, name);
        me._jCardForm.append(template);
        if (me.noCardFormAtStartFound) me._jCardForm.find(format(me._cardFormTabTemplate, name)).addClass("basic_padding");
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить наличие закладки боковой панели.
    * 
    * @method WebAccess.components.wrappers.sideBar.Tabs#isExist
    * @param tabName Имя закладки
    * @return {boolean} True, если закладка существует, иначе False.
    */
    isExist: function (tabName) {
      var me = this;

      var selector = format(me._byNameSelectorTemplate, me._tabSelector, tabName);
      me._jExistingTab = me._jSideBarConatainer.find(selector);
      return me._jExistingTab.length > 0;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.components.wrappers.sideBar.Tabs = Tabs;

})(window.WebAccess);